import React from "react";
import { Route, Routes } from "react-router";
import { useAuthorization } from "@common/providers";
import { useV2GetProjectByIdQuery } from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import useListLocations from "./api/useListLocations";
import useListServiceLocationVariables from "./api/useListProjectVariables";
import Show from "./Show/Show";
import Edit from "./Edit/Edit";
import New from "./New/New";

interface Props {
  project_id: string;
}

const ProjectLocationsV2Mspa: React.FC<Props> = ({ project_id }) => {
  const projectId = project_id;
  const { data: project, isLoading: projectLoading } = useV2GetProjectByIdQuery({
    id: String(projectId),
  });

  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const { locations, locationsLoading } = useListLocations({ projectId });

  const { variables, variablesLoading } = useListServiceLocationVariables();

  const authorized = useAuthorization();

  if (
    !authorized ||
    projectLoading ||
    privilegesLoading ||
    locationsLoading ||
    variablesLoading ||
    !project ||
    !user
  ) {
    return <ScopeStackSpinner />;
  }

  const projectStatus = project?.data?.attributes?.status || "";
  const permission = accessLevel("projects.locations") || "view";

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Show
            projectId={projectId}
            projectStatus={projectStatus}
            permission={permission}
          />
        }
      />
      <Route
        path="/edit/:locationId"
        element={
          <Edit
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
            locations={locations}
            projectVariableDefinitions={variables}
          />
        }
      />
      <Route
        path="/new"
        element={
          <New
            projectId={projectId}
            permission={permission}
            projectStatus={projectStatus}
            locations={locations}
            projectVariableDefinitions={variables}
          />
        }
      />
    </Routes>
  );
};

export default ProjectLocationsV2Mspa;
